import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { PageHeader } from "../components/Ui";
import { TruckLabTab } from "../components/lab/TruckLabTab";
import { CompositeLabTab } from "../components/lab/CompositeLabTab";
import { StackSampleLabTab } from "../components/lab/StackSampleLabTab";
import { PlantLabTab } from "../components/lab/PlantLabTab";

const VALID_TABS = ["truck", "composite", "stacks", "plant"];

const TAB_META = {
  truck: {
    title: "Truck Arrival Report",
    description: "Incoming truck lab analysis — moisture, admixture, damage, and bargaining thresholds.",
  },
  composite: {
    title: "Composite Report",
    description: "Post-unload composite samples linked to purchase transactions.",
  },
  stacks: {
    title: "Stack Sample Report",
    description: "Stack sample intake lines awaiting or completed lab analysis.",
  },
  plant: {
    title: "In Plant Report",
    description: "In-plant machine quality readings and paddy processing checks.",
  },
};

const TAB_CONTENT = {
  truck: TruckLabTab,
  composite: CompositeLabTab,
  stacks: StackSampleLabTab,
  plant: PlantLabTab,
};

export default function LabPage() {
  const { tab: routeTab } = useParams();
  if (!VALID_TABS.includes(routeTab)) {
    return <Navigate to="/lab/truck" replace />;
  }

  const meta = TAB_META[routeTab];
  const TabContent = TAB_CONTENT[routeTab];

  return (
    <div className="space-y-6 sm:space-y-8" data-testid="lab-page">
      <PageHeader
        eyebrow="Quality Control"
        title={meta.title}
        description={meta.description}
      />

      <div className="space-y-6">
        <TabContent />
      </div>
    </div>
  );
}
